<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加客户"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="客户名称：" prop="clientName">
            <el-input
              clearable
              :disabled="!canEditClientName"
              placeholder="请输入客户名称"
              size="mini"
              v-model="form.clientName"
            ></el-input>
          </el-form-item>
        </div>
        <el-row style="display: flex;align-items: center;" :gutter="16" v-for="(item, index) in contactList" :key="index">
          <el-col :span="13">
            <el-form-item label="客户联系人：">
              <el-input
                clearable
                size="mini"
                placeholder="请输入客户姓名"
                v-model="contactList[index]['contactUserName']"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-input
              clearable
              placeholder="请输入联系电话"
              size="mini"
              v-model="contactList[index]['contactUserPhone']"
            ></el-input>
          </el-col>
          <el-col :span="2">
            <el-button
              v-if="index === 0"
              @click="handleAddContact"
              size="medium"
              type="text"
              >添加</el-button
            >
            <el-button
              v-else
              @click="handleDelteContact(index)"
              class="delete-btn"
              size="medium"
              type="text"
              >删除</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    clientForm: {
      type: Object,
      required: false,
      default: () => ({
        id: null,
        clientName: null,
        contactList: [],
      }),
    },
  },
  data() {
    return {
      canEditClientName: true,
      form: {
        clientName: "",
        id: "",
      },
      contactList: [
        {
          contactUserName: null,
          contactUserPhone: null,
        },
      ],

      loading: false,
      rules: {
        clientName: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    if (this.clientForm && this.clientForm.id) {
      // 说明是添加客户联系人的
      this.form.clientName = this.clientForm.clientName;
      this.form.id = this.clientForm.id;
      this.contactList = [...this.clientForm.contactList];
      this.canEditClientName = false;
    } else {
      this.canEditClientName = true;
    }
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleAddContact() {
      this.contactList.push({
        contactUserName: null,
        contactUserPhone: null,
      });
    },
    handleDelteContact(index) {
      this.contactList.splice(index, 1);
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      this.$refs["ruleForm"].validate((valid) => {
        this.loading = true;
        if (this.clientForm.id) {
          // 更新 新增客户联系人
          if (this.contactList.length > 0) {
            let flag = false;
            for (let i = 0, len = this.contactList.length; i < len; i++) {
              const item = this.contactList[i];
              if (!item.contactUserName || !item.contactUserPhone) {
                flag = true;
                break;
              }
            }
            if (flag) {
              this.loading = false;
              this.$message.warning("客户联系人信息请填写完整");
              return;
            }
            updateClient({
              ...this.form,
              contactList: [...this.contactList],
            }).then((res) => {
              this.loading = false;
              this.$emit("confirm", null);
            });
          }
        } else {
          // 新增客户
          createClient({
            clientName: this.form.clientName,
            contactList: [...this.contactList],
          }).then((res) => {
            this.loading = false;
            if (res) {
              this.$emit("confirm", res);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.add-contacts-text-btn {
  margin-left: 10px;
}
.delete-btn {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/AddClient.vue